import React from 'react'
import { isDev } from '../../../helpers'
import { withParsedContext } from '../../Magazines/withJSSContext'

interface Props {
  parsedFields: {
    IsConfigurable: boolean
    ConfigurableAssetsRootUrl: string
  }
  pageEditing: boolean
}

const BottomScripts: React.FC<Props> = ({ parsedFields, pageEditing }) => {
  const isConfigurable = parsedFields.IsConfigurable || isDev
  const configurableAssetsRootUrl = parsedFields.ConfigurableAssetsRootUrl

  const mtiFontTracking = isConfigurable && `${configurableAssetsRootUrl}/mtiFontTrackingCode.min.js`

  return (
    <React.Fragment>
      {pageEditing ? <link href="/Assets/Discovery.Project.Website/V2023/css/sitecore.css" rel="stylesheet" /> : null}
      {mtiFontTracking ? <script src={mtiFontTracking}></script> : null}
    </React.Fragment>
  )
}

export default withParsedContext(BottomScripts as React.FC)
